import React, { ReactElement, useState } from 'react';
import { StyledCheckbox, HiddenCheckbox, CheckboxContainer, CheckboxLabel } from './Checkbox.styled';
import { ComponentProps as Props } from './Checkbox.types';
import Icon from '../Icon/Icon';

const Checkbox: React.FC<Props> = React.forwardRef<HTMLInputElement, Props>(
  ({ mode = 'primary', checked = false, label, onClick, ...props }, ref): ReactElement<Props> => {
    const [isChecked, setIsChecked] = useState<boolean>(checked);

    const handleOnClick = (event: React.MouseEvent) => {
      if (!props.disabled) {
        setIsChecked(!isChecked);
      }
      if (onClick) {
        onClick(event);
      }
    };

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setIsChecked(event.target.checked);
      if (props.onChange) {
        props.onChange(event);
      }
    };

    return (
      <CheckboxContainer className={props.className} onClick={handleOnClick}>
        <HiddenCheckbox type="checkbox" ref={ref} checked={isChecked} onChange={handleOnChange} {...props} />
        <StyledCheckbox mode={mode} isDisabled={props.disabled}>
          {isChecked ? <Icon type="accept" color={props.disabled && 'var(--color-smoke-70)'} /> : null}
        </StyledCheckbox>
        {label && <CheckboxLabel isDisabled={props.disabled}>{label}</CheckboxLabel>}
      </CheckboxContainer>
    );
  },
);

export default Checkbox;
